import { GambleCollectCommand } from "slotworks/commands/comms/gamble-collect-command";
import { GambleInitCommand } from "slotworks/commands/comms/gamble-init-command";
import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";
import GambleRecord from "slotworks/model/gameplay/records/gamble-record";
import Record from "slotworks/model/gameplay/records/record";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import SmartUIFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import { Exit } from "slotworks/state-machine/data/exit";
import Contract from "slotworks/utils/contracts/contract";
import WinCycle from "./win-cycle";

export default class WinCycleGamble extends WinCycle {
    private record?: Record;
    private collecting: boolean = false;

    public onEnter() {
        this.collecting = false;
        this.signalBindings.push(Components.gamble.onGambleStart.add(() => this.onGambleStart()));
        this.signalBindings.push(Components.gamble.onGambleCollect.add(() => this.onGambleCollect()));

        const gameplay = GameState.getCurrentGame();
        this.record = gameplay.getCurrentRecord();
        if (this.record instanceof SpinRecord || this.record instanceof GambleRecord) {
            if (this.record.gamble) {
                SmartUIFlags.set(SmartUIFlag.GAMBLE, true);
            }
        }

        super.onEnter();
    }

    public onSkip() {
        if (this.record && this.record.gamble) {
            if (!this.collecting) {
                SmartUIFlags.set(SmartUIFlag.GAMBLE, false);
                this.collecting = true;
                this.collect().then(() => {
                    super.onSkip();
                });
            }
        } else if (!this.collecting) {
            super.onSkip();
        }
    }

    public onExit() {
        if (this.record && this.record.gamble) {
            SmartUIFlags.set(SmartUIFlag.GAMBLE, false);
        }

        super.onExit();
    }

    public collapse() {
        if (this.record && this.record.gamble) {
            this.stateMachine.changeState(Exit.Collapse, this);
        } else {
            super.collapse();
        }
    }

    public onSubStateComplete() {
        if (this.collecting) {
            this.repeat();
        } else {
            this.complete();
        }
    }

    protected onGambleStart(): void {
        if (this.record && this.record instanceof SpinRecord) {
            GambleInitCommand().then(() => {
                this.record = GameState.getCurrentGame().nextRecord();
                this.collapse();
            });
        } else {
            this.collapse();
        }
    }

    protected onGambleCollect(): void {
        if (!this.collecting) {
            this.collecting = true;
            SmartUIFlags.set(SmartUIFlag.GAMBLE, false);
            this.collect().then(() => {
                this.collecting = false;
            });
        }
    }

    protected collect(): Contract<void> {
        SmartUIFlags.set(SmartUIFlag.AWAITING_RESPONSE, true);
        return new Contract<void>((resolve) => {
            GambleCollectCommand().then(() => {
                SmartUIFlags.set(SmartUIFlag.AWAITING_RESPONSE, false);
                this.record.gamble = false;

                resolve();
            });
        });
    }
}
